/* eslint-disable import/prefer-default-export */
// eslint-disable-next-line import/no-cycle
import baseApi from '@features/base/BaseSlice';
import label from './label';
import { LabelsProps } from './types';

const labelTag = baseApi.enhanceEndpoints({ addTagTypes: [label.tagType] });
const labelApi = labelTag.injectEndpoints({
  endpoints: (builder) => ({
    getLabels: builder.query<LabelsProps, void>(label.getLabels()),
  }),
  overrideExisting: false,
});

export const { useGetLabelsQuery } = labelApi;
